import { FC, ReactNode } from 'react';
import { Button } from './styles';

interface SmallCircleButtonProps {
	onClick?: () => void;
	children?: ReactNode;
	color?: string;
	size?: string;
}

export const SmallCircleButton: FC<SmallCircleButtonProps> = ({
	onClick,
	children,
	color,
	size,
}) => {
	return (
		<Button $color={color} $size={size} onClick={onClick}>
			{children}
		</Button>
	);
};
